import type { ReactNode } from 'react';

interface RepoListEmptyProps {
  isSignedIn: boolean;
}

/**
 * S-UI-002: Empty-list state when no repos are indexed.
 * Auth-aware copy — admin note omitted when signed out.
 */
export function RepoListEmpty({ isSignedIn }: RepoListEmptyProps): ReactNode {
  return (
    <div data-testid="repo-list-empty" className="repo-list-empty">
      No repositories indexed yet.
      {isSignedIn && ' Use the Admin panel above to onboard one.'}
    </div>
  );
}
